/* Brain Age LP: links to the product card (#choose-your-muse, CTA map 01 and 11). The browser's own jump would leave the
   card under the sticky site header, whose height changes by breakpoint, so the click is handled here: the card's top edge
   lands 16px below the header (the gap the "What you see" card pins at). Loaded by the hero and the final CTA; runs once. */
(function () {
  if (window.baLinksReady) return;
  window.baLinksReady = true;
  var GAP = 16;

  function headerBottom() {
    // Only a header at the top counts: on INTL mobile the floating header sits in the lower half of the screen
    var nav = document.querySelector('.v2-floating-header__navbar');
    if (!nav) return 0;
    var r = nav.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight / 2 ? r.bottom : 0;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#choose-your-muse"]');
    var anchor = link && document.getElementById('choose-your-muse');
    if (!anchor) return;
    e.preventDefault();
    // The anchor sits at the end of the section before the product card; aim at the card itself when it follows.
    var card = document.querySelector('.pps-card');
    var target = card && anchor.compareDocumentPosition(card) & Node.DOCUMENT_POSITION_FOLLOWING ? card : anchor;
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerBottom() - GAP;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // While the page glides there, the "What you see" slider must not read a stutter as "scrolling stopped" and snap to a
    // slide (mobile, brain-age-slides.js): it checks this until the scroll settles.
    window.baJumping = Date.now();
    var last = -1, still = 0, watch = setInterval(function () {
      var cur = window.pageYOffset;
      still = cur === last ? still + 1 : 0; last = cur;
      if (still >= 3 || Date.now() - window.baJumping > 4000) { window.baJumping = 0; clearInterval(watch); }
    }, 100);
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#choose-your-muse');
  });
})();
